/**
 * SuiteScanner's booking fee is based on the supplier's whole-stay hotel
 * booking value in USD, before the SuiteScanner fee is added.
 */
export function bookingFeeUsd(hotelBookingValueUsd: number): number {
  if (!Number.isFinite(hotelBookingValueUsd) || hotelBookingValueUsd < 0) {
    throw new RangeError('Hotel booking value must be a non-negative finite USD amount');
  }

  if (hotelBookingValueUsd < 1000) return 39;
  if (hotelBookingValueUsd <= 2000) return 69;
  return 99;
}

/**
 * Average card-processing cost, added to every supplier price before the
 * guest sees it. The supplier is still paid its own amount.
 */
export const CARD_FEE_PERCENT = 3;

/** Card fee on a supplier amount, rounded up to the cent. */
export function cardFee(supplierAmount: number): number {
  if (!Number.isFinite(supplierAmount) || supplierAmount < 0) {
    throw new RangeError('Supplier amount must be a non-negative finite number');
  }
  return Math.ceil(Math.round(supplierAmount * 100) * CARD_FEE_PERCENT / 100) / 100;
}

/** The price the guest sees: supplier amount plus the card fee. */
export function withCardFee(supplierAmount: number): number {
  return Math.round((supplierAmount + cardFee(supplierAmount)) * 100) / 100;
}

/** Inverse of `withCardFee`, for turning a price the guest typed into a supplier-side filter. */
export function withoutCardFee(shownAmount: number): number {
  return shownAmount * 100 / (100 + CARD_FEE_PERCENT);
}
